export default {
  state: {
    branchList: [],
    saleGroupList: [],
    filialList: [],
    branchTitleList: [],
    saleGroupTitleList: [],
    filialTitleList: [],
    distributionChannelList: []
  },
  mutations: {
    setBranchList (state, payload) {
      state.branchList = payload
      state.branchTitleList = []
      state.branchTitleList[0] = 'Все филиалы'
      for (let i = 0; i < state.branchList.length; i++) {
        state.branchTitleList[state.branchTitleList.length] = state.branchList[i].title
      }
    },
    setSaleGroupListList (state, payload) {
      state.saleGroupList = payload
      state.saleGroupTitleList = []
      state.saleGroupTitleList[0] = 'Все супервайзеры'
      for (let i = 0; i < state.saleGroupList.length; i++) {
        state.saleGroupTitleList[state.saleGroupTitleList.length] = state.saleGroupList[i].title
      }
    },
    setFilialList (state, payload) {
      state.filialList = payload
      state.filialTitleList = []
      state.filialTitleList[0] = 'Все направления'
      for (let i = 0; i < state.filialList.length; i++) {
        state.filialTitleList[state.filialTitleList.length] = state.filialList[i].title
      }
      console.log(state.filialList)
    },
    setDistributionChannelList (state, payload) {
      state.distributionChannelList = payload
    }
  },
  actions: {
    getBranchList ({commit, dispatch}) {
      const url = '/admin/branch/list?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setBranchList', data.branch_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getSaleGroupList ({commit, dispatch}, {branchId}) {
      const url = '/admin/sale/group/list?access_token=' + this.getters.accessToken + '&branch_id=' + branchId
      dispatch('apiGet', url)
        .then((data) => {
          commit('setSaleGroupListList', data.sale_group_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getFilialList ({commit, dispatch}, {branchId}) {
      const url = '/admin/filial/list?access_token=' + this.getters.accessToken + '&branch_id=' + branchId
      dispatch('apiGet', url)
        .then((data) => {
          commit('setFilialList', data.list)
        })
        .catch((error) => {
          throw error
        })
    },
    getDistributionChannelList ({commit, dispatch}) {
      const url = '/admin/distribution/channel?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setDistributionChannelList', data.distribution_channel_list)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    branchList (state) {
      return state.branchList
    },
    saleGroupList (state) {
      return state.saleGroupList
    },
    filialList (state) {
      return state.filialList
    },
    branchTitleList (state) {
      return state.branchTitleList
    },
    saleGroupTitleList (state) {
      return state.saleGroupTitleList
    },
    filialTitleList (state) {
      return state.filialTitleList
    },
    distributionChannelList (state) {
      return state.distributionChannelList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/branch.js